import type { ModelContextLike, ProductistWebMcpHarness, WebMcpToolDefinition } from "./types";

export function installDirectToolHarness(documentRef: Document, windowRef: Window): ProductistWebMcpHarness {
  const tools = new Map<string, WebMcpToolDefinition>();
  const modelContext: ModelContextLike = {
    registerTool(tool, options) {
      tools.set(tool.name, tool);
      options?.signal?.addEventListener("abort", () => {
        if (tools.get(tool.name) === tool) tools.delete(tool.name);
      }, { once: true });
    },
  };
  Object.defineProperty(documentRef, "modelContext", { configurable: true, value: modelContext });
  const harness: ProductistWebMcpHarness = {
    names: () => [...tools.keys()],
    schema: (name) => tools.get(name)?.inputSchema,
    async call(name, input) {
      const tool = tools.get(name);
      if (!tool) throw new Error(`WebMCP tool not registered: ${name}`);
      return tool.execute(input, { signal: new AbortController().signal });
    },
  };
  windowRef.__PRODUCTIST_WEBMCP_HARNESS__ = harness;
  return harness;
}
